import React, { useState, useEffect } from "react";
import { Modal, Button, Nav, NavItem, NavLink } from 'react-bootstrap';
import './Campaigns.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const ModalInstructions = ({ show, handleModalhide }) => {



    return (
        <>
            <Modal
                show={show}
                onHide={handleModalhide}
                size="lg"
                centered
                contentClassName="campaign-card border-0"
                style={{ backgroundColor: 'transparent' }}
            >
                <Modal.Header closeButton className="border-0 pb-0" style={{ background: '#0f172a', border: 'none' }}>
                    <Modal.Title className="campaigns-section-title fs-3 mb-0">💡 Instruções de Campanhas</Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-0" style={{ background: '#0f172a', border: 'none' }}>
                    <div className="row mt-3">
                        <div className="col-12">
                            <Tabs
                                defaultActiveKey="notifications"
                                id="campaign-instructions-tabs"
                                className="mb-4 premium-tabs"
                                style={{ background: 'transparent' }}
                            >
                                <Tab eventKey="notifications" title={<span><i className="fa-solid fa-bell me-2"></i>Notificações</span>}>
                                    <div className="p-4 instruction-box rounded-4">
                                        <h5 className="text-white mb-3">Push Notifications App</h5>
                                        <p className="text-muted">As notificações são uma forma poderosa e direta de publicitar o seu Spot ou Evento junto do seu público mais fiel.</p>
                                        <ul className="text-muted small">
                                            <li className="mb-2"><b>Público Alvo:</b> Utilizadores que já se inscreveram nas suas guest lists e têm a App Nightspot instalada.</li>
                                            <li className="mb-2"><b>Ação Direta:</b> Permite que, com um clique, o cliente aceda instantaneamente à página do evento ou spot.</li>
                                            <li className="mb-2"><b>Segmentação:</b> Pode filtrar os destinatários por género e faixa etária para maior eficácia.</li>
                                            <li><b>Custo:</b> Este canal de comunicação é otimizado para gerar conversões rápidas na App.</li>
                                        </ul>
                                    </div>
                                </Tab>
                                <Tab eventKey="sms" title={<span><i className="fa-solid fa-comment-sms me-2"></i>SMS</span>}>
                                    <div className="p-4 instruction-box rounded-4">
                                        <h5 className="text-white mb-3">Mensagens Curtas (SMS)</h5>
                                        <p className="text-muted">O SMS garante uma taxa de abertura superior a 90%, sendo ideal para anúncios de última hora ou eventos exclusivos.</p>
                                        <ul className="text-muted small">
                                            <li className="mb-2"><b>Fontes de Dados:</b> Inscritos em guest lists e contactos importados via Excel no menu de "Lista de Contactos".</li>
                                            <li className="mb-2"><b>Alcance Total:</b> Chega a qualquer telemóvel, independentemente de ter a aplicação instalada.</li>
                                            <li><b>Segmentação:</b> Também permite filtrar por idade e género para personalizar a mensagem.</li>
                                        </ul>
                                    </div>
                                </Tab>
                                <Tab eventKey="whatsapp" title={<span><i className="fa-brands fa-whatsapp me-2"></i>WhatsApp</span>}>
                                    <div className="p-4 instruction-box rounded-4">
                                        <h5 className="text-whatsapp mb-3" style={{ color: '#25D366' }}>Campanhas WhatsApp</h5>
                                        <p className="text-muted">Aproveite a app de mensagens mais utilizada em Portugal para criar uma relação próxima com os seus clientes.</p>
                                        <ul className="text-muted small">
                                            <li className="mb-2"><b>Interatividade:</b> Formato rico que permite envio de links e uma comunicação mais visual.</li>
                                            <li className="mb-2"><b>Lista de Contactos:</b> Utiliza a sua base de dados de clientes registados e contactos importados.</li>
                                            <li className="mb-2"><b>Eficácia:</b> Alta taxa de leitura e facilidade de partilha direta entre amigos dos clientes.</li>
                                            <li><b>Nota:</b> Certifique-se de que a mensagem é relevante para evitar ser reportado como spam.</li>
                                        </ul>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0" style={{ background: '#0f172a', border: 'none' }}>
                    <Button variant="secondary" onClick={handleModalhide} className="btn-campaign-secondary px-4 rounded-pill border-0">
                        Entendido
                    </Button>
                </Modal.Footer>
            </Modal>



        </>
    )
}


export default ModalInstructions